import { getHotelFiltersByFilterOrderAndCount } from 'home/components/OfferCarousels/utils'
import { useAppSelector } from 'hooks/reduxHooks'
import getOfferListKey from 'lib/offer/offerListKey'
import { useMemo } from 'react'

export default function useHolidayTypes(filters: App.OfferListFilters, numberOfFilters: number) {
  const filterKey = useMemo(() => getOfferListKey(filters), [filters])
  const filterOptions = useAppSelector((state) => state.offer.offerListFilterOptions[filterKey])

  const filtersResult = useMemo(() => {
    const filtersResult = getHotelFiltersByFilterOrderAndCount(filterOptions?.filters?.holidayTypes, filterOptions?.filterOrder?.holidayTypes, numberOfFilters + 1, 3) || []
    return filtersResult.filter(f => f !== 'Honeymoon').slice(0, numberOfFilters)
  }, [filterOptions, numberOfFilters])

  return filtersResult
}
